import { hasMouse, onMouse } from '../utils/has-mouse';

/*
 * Second photo on the VIEW MORE cards (snippets/slider-products.liquid).
 *
 * The photo's address is kept in data-* attributes, so a card only downloads its
 * hover photo once there is a mouse that could hover it.
 */

const load = (img: HTMLImageElement) => {
  if (!img.dataset.src) return;

  if (img.dataset.srcset) img.srcset = img.dataset.srcset;
  img.src = img.dataset.src;
  delete img.dataset.src;
};

const loadWithin = (root: ParentNode) =>
  root.querySelectorAll<HTMLImageElement>('.m-products__hover-image[data-src]').forEach(load);

onMouse(() => loadWithin(document));

// related products are fetched after the page loads, so cards can turn up later
document.addEventListener('mouseover', (event) => {
  if (!hasMouse()) return;

  const card = (event.target as HTMLElement).closest?.('.m-products__item');
  if (card) loadWithin(card);
});
